import React from "react";
import MyNavbar from "../Shear/MyNavbar/MyNavbar";
import image from "../../abuhorain.png";
import "./About.css";
import FooterC from "../Shear/FooterC/FooterC";
import Typed from "react-typed";

const About = () => {
  return (
    <main className="">
      <MyNavbar />
      <section className="container my-5">
        <div className="row">
          <div className="col-md-6">
            <div>
              <div className="text-center">
                <img className="img-fluid rounded-circle" src={image} alt="" />
              </div>{" "}
              <div className="">
                <h2>
                  <span style={{ color: "#01DF01" }}>I'm</span> Abu Horain
                </h2>
                <h3>
                  <Typed
                    strings={[
                      "Web Developer",
                      "React Developer",
                      "Front-end Developer",
                      "MERN Stack Developer",
                      "Javascript Developer",
                      "Programmer...!",
                    ]}
                    typeSpeed={40}
                    backSpeed={40}
                    attr="placeholder"
                    loop
                  >
                    <input className="typedAbout" type="text" />
                  </Typed>
                </h3>
                <p>
                  {" "}
                  I am studying Diploma in-engineering Telecommunication
                  Technology at Feni Computer Institute. I am MERN stack web
                  Develop.
                </p>
                <p className="">
                  Expert in developing Single Page Application(SPA) using
                  React.js and Node.js. I have a good knowledge in the
                  Javascript, ES6, Bootstap-4 and also comfortable with Material
                  UI, Express.js and MongoDB.
                </p>
                <p>
                  Client satisfaction is my pride. Love to develop modern and
                  impressive websites for my clients and always responsible for
                  the job.
                </p>
                <p className="">
                  Well-qualified Full Stack Developer familiar with wide range
                  of programming utilities and languages. Knowledgeable of
                  backend and frontend development requirements. Handles any
                  part of process with ease. Collaborative team player with
                  excellent technical abilities offering 0.6 years of related
                  experience.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <section className="">
              <div className="">
                <h4>My Skills Set</h4>
                <div className="skill">
                  <span>JavaScript</span>
                  <span>ReactJS</span>
                  <span>NodeJS</span>
                  <span>ExpressJS</span>
                  <span>MongoDB</span>
                  <span>ReduxJS</span>
                  <span>NextJS</span>
                  <span>Bootstrap</span>
                  <span>Material-UI</span>
                  <span>HTML | HTML-5</span>
                  <span>CSS | CSS-3</span>
                  <span>Git</span>
                  <span>NPM</span>
                  <span>VS Code</span>
                  <span>Firebase</span>
                  <span>Netlify</span>
                  <span>Heroku</span>
                  <span>Python</span>
                  <span>Basic Computer Networking</span>
                </div>
              </div>
              {/* <div className="my-3">
                <h4>Expertise Skills</h4>
                <div className="skill">
                  <span>JavaScript</span>
                  <span>ReactJS</span>
                  <span>NodeJS</span>
                  <span>ExpressJS</span>
                  <span>MongoDB</span>
                  <span>Bootstrap</span>
                  <span>Material-UI</span>
                  <span>HTML | HTML-5</span>
                  <span>CSS | CSS-3</span>
                </div>
              </div> */}

              {/* <div className="">
                                <h4>Comfortable Skills</h4>
                                <div className="skill">
                                    <span>Node.js</span>
                                    <span>Express.js</span>
                                    <span>Firebase</span>
                                    <span>Netlify</span>
                                    <span>Heroku</span>
                                    <span>Python</span>
                                    <span>Computer Networking</span>
                                </div>
                            </div> */}

              <div className="my-3">
                <h4>Tools</h4>
                <div className="skill">
                  <span>Git</span>
                  <span>NPM</span>
                  <span>YARN</span>
                  <span>VS Code</span>
                  <span>Chrome Dev Tools</span>
                </div>
              </div>
              <div className="">
                <h4>I want to work with</h4>
                <div className="skill">
                  <span>JavaScript</span>
                  <span>ReactJS</span>
                  <span>NodeJS</span>
                  <span>ExpressJS</span>
                  <span>MongoDB</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <FooterC />
    </main>
  );
};

export default About;
